var map = {
	"./block.less": 340,
	"./clients.less": 341,
	"./common.less": 342,
	"./competencies.less": 343,
	"./contacts.less": 344,
	"./feedback.less": 345,
	"./fonts.less": 346,
	"./footer.less": 347,
	"./gov-support.less": 348,
	"./header.less": 349,
	"./inc/mixins.less": 350,
	"./inc/vars.less": 351,
	"./location.less": 352,
	"./map.less": 353,
	"./page.less": 354,
	"./place.less": 355,
	"./reset.less": 356,
	"./transport.less": 357
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 339;



//////////////////
// WEBPACK FOOTER
// ./src/less ^(.*\.(less))[^.]*$/i
// module id = 339
// module chunks = 0